var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-mic-1045070 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.8765 8.08229C15.5727 8.08229 15.3265 8.32399 15.3265 8.62229V11.4303C15.3265 13.7726 13.3857 15.6781 11 15.6781C8.61433 15.6781 6.67349 13.7726 6.67349 11.4303V8.62229C6.67349 8.32399 6.42731 8.08229 6.12349 8.08229C5.81967 8.08229 5.57349 8.32399 5.57349 8.62229V11.4303C5.57349 14.1858 7.71519 16.4594 10.45 16.7309V19.5299H9.05653C8.75271 19.5299 8.50653 19.7716 8.50653 20.0699C8.50653 20.3682 8.75271 20.6099 9.05653 20.6099H12.9435C13.2473 20.6099 13.4935 20.3682 13.4935 20.0699C13.4935 19.7716 13.2473 19.5299 12.9435 19.5299H11.55V16.7309C14.2848 16.4594 16.4265 14.1858 16.4265 11.4303V8.62229C16.4265 8.32399 16.1803 8.08229 15.8765 8.08229ZM11 15.066C13.0319 15.066 14.685 13.443 14.685 11.448V4.60814C14.685 2.61317 13.0319 0.990143 11 0.990143C8.96809 0.990143 7.31501 2.61317 7.31501 4.60814V11.448C7.31501 13.443 8.96809 15.066 11 15.066ZM8.41501 4.60814C8.41501 3.20868 9.57463 2.07014 11 2.07014C12.4254 2.07014 13.585 3.20868 13.585 4.60814V11.448C13.585 12.8475 12.4254 13.986 11 13.986C9.57463 13.986 8.41501 12.8475 8.41501 11.448V4.60814Z",
    fill: "#303E4E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.d69334177b669759c870d8480e019ad4.svg";
export { ForwardRef as ReactComponent };